import React, { useEffect, useRef, useState } from "react";
import styles from "./sortDropDown.module.css";
import { useDispatch, useSelector } from "react-redux";
import useTranslation from "next-translate/useTranslation";
import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";

function index({ map }: { map?: boolean }) {
  const { t, lang } = useTranslation("annonceAchat");
  const dispatch = useDispatch();

  const searchPayload: any = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );
  const SORT_LABELS = {
    "": t("Recommandées"),
    date_desc: t("Nouveautées"),
    price_asc: t("Prix moins cher"),
    price_desc: t("Prix plus cher"),
  };
  const SORT_OPTIONS = [
    {
      value: "",
      label: t("Recommandées"),
    },
    {
      value: "date_desc",
      label: t("Nouveautées"),
    },
    {
      value: "price_asc",
      label: t("Prix moins cher"), // this translate in arabic and french to help special characters like ":, ? , ..ect"
    },
    {
      value: "price_desc",
      label: t("Prix plus cher"),
    },

    // {
    //   value: "date_asc",
    //   label:
    //     searchPayload?.transaction_type == "Projets Neufs"
    //       ? t("Livré le plus tard")
    //       : t("Date - Du plus ancien au plus récent"),
    // },
  ];
  const [sortSelected, setSortSelected] = useState(
    searchPayload.sort
      ? SORT_LABELS[searchPayload.sort]
        ? SORT_LABELS[searchPayload.sort]
        : t("Recommandées")
      : t("Recommandées")
  );

  const initialMessageRef = useRef("Recommandées");

  const [displayDropdown, setDisplayDropdown] = useState(false);

  //   const handleSort = (value, label)=>{
  //     dispatch(
  //         ListingreducerActions.setSearchPayload({
  //           searchPayload: {
  //             page: 0,
  //             sort: value,
  //             label: label,
  //           },
  //         })
  //       );
  //     }

  const dropdown = useRef(null);
  const parentRec = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdown.current &&
        !dropdown.current.contains(event.target) &&
        !parentRec.current.contains(event.target)
      ) {
        setDisplayDropdown(false);
      }
    };
    document.addEventListener("click", handleOutsideClick, true);
  }, []);

  return (
    <div className={styles.try}>
      <div className={styles.triesPar}>
        {t("Triées par")}
        {":"}
      </div>
      <div>
        <div
          className={styles.recommandesParent}
          data-tracking="click"
          data-value="tri-annonce"
          onClick={(e) => {
            setDisplayDropdown(displayDropdown ? false : true);
          }}
          ref={parentRec}
          style={{ border: displayDropdown ? "solid 1px black" : "" }}
        >
          <div className={styles.recommandes}>{sortSelected}</div>
          <span className={styles.iconoutlinechevronDown}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="7"
              viewBox="0 0 14 8"
              fill="none"
              className={displayDropdown ? styles.switch_top : ""}
            >
              <path
                d="M13 1L7 7L1 1"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
      {displayDropdown ? (
        <div
          className={styles.sortOptions}
          ref={dropdown}
          style={{ top: map ? "120px" : "" }}
        >
          {searchPayload.vendu ? (
            SORT_OPTIONS.slice(0, 2).map((sortOption, index) => (
              <div
                key={sortOption.value}
                className={styles.sortOptionslink}
                onClick={(e) => {
                  dispatch(
                    ListingreducerActions.setSearchPayload({
                      searchPayload: {
                        page: 0,
                        sort: sortOption.value,
                        label: sortOption.label,
                      },
                    })
                  );
                  // setSortSelected(sortOption.label);
                  setDisplayDropdown(false);
                }}
                style={{
                  color: sortOption.label == sortSelected ? "black" : "",
                  borderTopRightRadius: index == 0 ? "8px" : "",
                  borderTopLeftRadius: index == 0 ? "8px" : "",
                  borderBottomLeftRadius:
                    index == SORT_OPTIONS.length - 1 ? "8px" : "",
                  borderBottomRightRadius:
                    index == SORT_OPTIONS.length - 1 ? "8px" : "",
                }}
              >
                {t(sortOption.label)}
              </div>
            ))
            ) : (
              SORT_OPTIONS.map((sortOption, index) => (
                <div
                  key={sortOption.value}
                  className={styles.sortOptionslink}
                  onClick={(e) => {
                    dispatch(
                      ListingreducerActions.setSearchPayload({
                        searchPayload: {
                          page: 0,
                          sort: sortOption.value,
                          label: sortOption.label,
                        },
                      })
                    );
                    // setSortSelected(sortOption.label);
                    setDisplayDropdown(false);
                  }}
                  style={{
                    color: sortOption.label == sortSelected ? "black" : "",
                    borderTopRightRadius: index == 0 ? "8px" : "",
                    borderTopLeftRadius: index == 0 ? "8px" : "",
                    borderBottomLeftRadius:
                      index == SORT_OPTIONS.length - 1 ? "8px" : "",
                    borderBottomRightRadius:
                      index == SORT_OPTIONS.length - 1 ? "8px" : "",
                  }}
                >
                  {t(sortOption.label)}
                </div>
              ))
          )
          }
        </div>
      ) : null}
    </div>
  );
}

export default index;
